export default __webpack_public_path__ + "static/media/manutencao.c1c373a7.png";